import * as DataProviders from '../../types/data-providers';
import * as LocationManager from '../domain/location-manager';
import React from 'react';
import { useData, dataFromDataset } from './DataProviderCache';
import { useAuthHelper } from '../../components/AuthContextProvider';

type ContextState = DataProviders.Data<number>;

const Context = React.createContext<ContextState | null>(null);

function useLocationsDropdownAlarmCountData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useLocationsDropdownAlarmCount must be used within a LocationsDropdownAlarmCountProvider');
    }
    return contextState;
}

const LocationsDropdownAlarmCountProvider: React.FC<{ organizationOrLocationId: string | undefined }> = (props) => {
    const authHelper = useAuthHelper();

    const dataObj = useData({
        cacheKey: 'locations-dropdown-alarm-count-data',
        id: props.organizationOrLocationId || '--',
        dataFn: React.useCallback(
            () =>
                props.organizationOrLocationId
                    ? LocationManager.getAlarmCountForLocation(authHelper, props.organizationOrLocationId)
                    : new Promise<number>(() => {
                          // No organization or location specified, so never resolve
                      }),
            [authHelper, props.organizationOrLocationId ]
        ),
    });
    const statusData = dataFromDataset(dataObj.dataset);

    return <Context.Provider value={statusData}>{props.children}</Context.Provider>;
};

const TestLocationsDropdownAlarmCountProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export {
    LocationsDropdownAlarmCountProvider,
    TestLocationsDropdownAlarmCountProvider,
    useLocationsDropdownAlarmCountData,
};
